import React, { Component } from 'react';
import Input from '../uielements/input';
import Button from '../uielements/button';

export default class extends Component {
  state = {};
  render() {
    const { searchText, onInputChange, onSearch } = this.props;
    let {placeholder} = this.props;
    placeholder = placeholder ? placeholder : 'Email or phone number';
    return (
      <div className="isoTableSearchBox">
        <Input
          id="tableFilterInput"
          placeholder={placeholder}
          value={searchText}
          onChange={onInputChange}
          onPressEnter={onSearch}
        />
        <Button type="primary" onClick={onSearch}>
          Search
        </Button>
      </div>
    );
  }
}
